// extracted by mini-css-extract-plugin
export default {"root":"style_root__9mxMu","btnContainer":"style_btnContainer__6oxE_","btn":"style_btn__7s5-q","collapseHeader":"style_collapseHeader__3caIM","agreement":"style_agreement__2-h1q"};